import { Component, OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { veteranMilitaryStaus, veteranMilitaryBranch } from '../../../../constants';

@Component({
  selector: 'military',
  templateUrl: 'military.component.html'
})

export class MilitaryComponent implements OnInit {
  branchdata = [];
  formClass: string = "";
  errormsg: any[] = new Array();
  errdisplay: boolean = false;
  checkPrev: number = 0;
  isLoader: boolean = false;
  trackingName = "Military";

  constructor(private _services: ServiceInterface, public _parent: PworkflowComponent, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Military";
    }
    
    this.branchdata = await this._services.getList('/branch');
    var elmnt = document.getElementById("top");
    elmnt.scrollIntoView();
    if (this._parent.model.uuid) {
      if (this._parent.model.secondary_bucket.length == 0) {
        let secBucket = await this._services.getList('/secondarybucketlist/' + this._parent.model.bucket_id)
          secBucket.forEach(data => {
            this._parent.model.secondary_bucket.push({
              id: data.secBucketId,
              name: data.secBucketTitle
            }) 
          })
        this._parent.model.secondary_bucket_ids = this._parent.model.secondary_bucket.map(a => a.id).join(',');
      }
      this.checkPrev = await this._services.post('/flow/check/previousdata', this._parent.model);
      //console.log("Check:",this.checkPrev);
    }
  }

  clickSubmit(valid) {

    this.errormsg = [];
    if (valid) {
      this.militarysubmit();
    } else {
      if (this._parent.model.military_branch == "") {
        this.errdisplay = true;
        this.errormsg.push("Please enter branch of service.");
      }
      if (!(this._parent.model.military_status)) {
        this.errdisplay = true;
        this.errormsg.push("Please enter military status.");
      }
      this.formClass = "validate";
    }
  }

  async militarysubmit() {
    //console.log("Sdata:",this._parent.model);
    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 4);
    if (this._parent.model.uuid) {
      this.isLoader = true;
      await this._services.post('/search/updateinfo', this._parent.model);
      // Manage degree level for scholarships
      let eduGoal = '';
      if(this._parent.model.education_goal == "5"){
        eduGoal = "academic_level_undergraduate";
      }else if(this._parent.model.education_goal == "7" || this._parent.model.education_goal == "17"){
        eduGoal = "academic_level_post_graduate";
      }else if(this._parent.model.education_goal == "18"){
        eduGoal = "academic_level_certificate"
      }else if(this._parent.model.education_goal == "3" || this._parent.model.education_goal == "18"){
        eduGoal = "academic_level_trade_vocational";
      }
      // Manage Military Branch for scholarships
      let branchOfService = "";
      let mbindex = veteranMilitaryBranch.findIndex(x => x.id == this._parent.model.military_branch);
      if(mbindex < 0){
        branchOfService = "";
      }else{
        branchOfService = veteranMilitaryBranch[mbindex].name;
      }
      // Manage Military Status for scholarships
      let serviceStatus = "";
      let msindex = veteranMilitaryStaus.findIndex(x => x.name.toLowerCase() == this._parent.model.military_status.toLowerCase());
      if(msindex < 0){
        serviceStatus = "";
      }else{
        serviceStatus = veteranMilitaryStaus[msindex].value;
      }
      let scholarUpdate = {
        "uuid": this._parent.model.uuid,
        "educationGoal": eduGoal,
        "studyState": this._parent.model.study_state_values,
        "militaryBranch": branchOfService,
        "militaryStatus": serviceStatus,
        "bucketId": this._parent.model.bucket_id,
        "secondaryBucketId": this._parent.model.secondary_bucket_ids
      }
      await this._services.post('/veteran/scholarshipdata/update', scholarUpdate);
      let collegesData = await this._services.post('/search/matchdata', this._parent.model);
      let profileCollegeCheck = "";
      if (this._parent.model.passedIn_college_id)
      {
        profileCollegeCheck = await this._services.post('/search/collegeprofile/checkcollege', this._parent.model);
      }
      
      // console.log("Check:", profileCollegeCheck);
      if (this.checkPrev != 1) {
        this.saveFiltertracking(this._parent.model);
        this.saveSearchresultTracking(this._parent.model, collegesData);
        for (var i = 0; i < collegesData.length; i++) {
          let matchData = {
            "studentId": this._parent.model.uuid,
            "collegeId": collegesData[i]['collegeId'],
            "matchPercent": collegesData[i]['percentMatch'],
            "src": "Flow",
            "contacted": "No",
            "isPassedInCollege": (collegesData[i]['collegeId'] == this._parent.model.passedIn_college_id) ? 1 : 0
          }
          await this._services.post('/flow/match/saveupdate/collegelist', matchData);
        }
         let updataData = {
           "studentId": this._parent.model.uuid,
           "collegeId": collegesData.map(a => a.collegeId).join(',')
         }
         await this._services.post('/flow/match/checkdelete/collegelist', updataData);
      } else if (this._parent.model.passedIn_college_id && profileCollegeCheck == 'notexist') {
        let matchCollege = collegesData.find(x => x.collegeId == this._parent.model.passedIn_college_id);
        let insertCollege = {
          "studentId": this._parent.model.uuid,
          "collegeId": this._parent.model.passedIn_college_id,
          "contacted": "No",
          "src": "Flow",
          "matchPercent": matchCollege.percentMatch,
          "isPassedInCollege": 1
        }
        await this._services.post('/search/profile/matchcollege/insert', insertCollege);
      } else if (this._parent.model.passedIn_college_id && profileCollegeCheck == 'exist') {
        let matchData = {
          "studentId": this._parent.model.uuid,
          "collegeId": this._parent.model.passedIn_college_id,
          "isPassedInCollege": 1
        }
        await this._services.post('/search/profile/matchcollege/update', matchData);
      }

      this.isLoader = false;
      this._parent.index = 6;
    } else {
      this._parent.index++;
    }
  }
  prevAction() {
    this._parent.index--;
  }

  async saveFiltertracking(trackdata) {
    // track major data
    let majordata = trackdata.secondary_bucket;
    for (let index = 0; index < majordata.length; index++) {
      let trackData = {
        "primarySource": "program matcher",
        "secondarySource": "login",
        "filterType": "secondary bucket",
        "value": majordata[index]['id']
      }
      await this._services.post('/college/filter/tracking', trackData);
    }
    // track state data
    let statedata = trackdata.study_state;
    for (let index = 0; index < statedata.length; index++) {
      let trackData1 = {
        "primarySource": "program matcher",
        "secondarySource": "login",
        "filterType": "state",
        "value": statedata[index]['value']
      }
      await this._services.post('/college/filter/tracking', trackData1);
    }
    // track level data
    let trackData2 = {
      "primarySource": "program matcher",
      "secondarySource": "login",
      "filterType": "level",
      "value": trackdata.education_goal
    }
    await this._services.post('/college/filter/tracking', trackData2);
    // track bucket data
    let trackData3 = {
      "primarySource": "program matcher",
      "secondarySource": "login",
      "filterType": "bucket",
      "value": trackdata.bucket_id
    }
    await this._services.post('/college/filter/tracking', trackData3);
  }

  async saveSearchresultTracking(trackdata, collegeinfo) {
    let trackData = {
      "primarySource": "program matcher",
      "secondarySource": "login",
      "filters": JSON.stringify(trackdata),
      "collegeList": collegeinfo.map(a => a.collegeId).join(',')
    }
    await this._services.post('/searchresult/colleges/tracking', trackData);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/military/military.component.ts